import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Stack,
  Text,
  styled,
} from '@ltvco/refresh-lib/theme';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: '700px',
    maxWidth: '90vw',
    borderRadius: theme.spacing(2),
  },
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  position: 'relative',
  borderBottom: `1px solid ${theme.palette.divider}`,
  paddingBottom: theme.spacing(2),
  paddingTop: theme.spacing(4),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(3),
  marginBottom: 0,
  [theme.breakpoints.up('sm')]: {
    paddingTop: theme.spacing(2),
  },
}));

export const TitleText = styled(Text)(({ theme }) => ({
  width: '100%',
  textAlign: 'center',
  fontWeight: 'bold',
  fontSize: '1.25rem',
  lineHeight: 1.3,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  wordBreak: 'break-word',
  hyphens: 'auto',
  [theme.breakpoints.up('sm')]: {
    fontSize: '1.5rem',
    lineHeight: 1.4,
    paddingLeft: 0,
    paddingRight: 0,
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '2rem',
  },
}));

export const CloseIconButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500],
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  textAlign: 'center',
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  [theme.breakpoints.up('sm')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export const BodyText = styled(Text)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  fontSize: '0.9rem',
  [theme.breakpoints.up('sm')]: {
    fontSize: '1rem',
  },
}));

export const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  paddingTop: theme.spacing(2),
  justifyContent: 'center',
  [theme.breakpoints.up('sm')]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}));

export const ActionsStack = styled(Stack)({
  width: '100%',
});

export const CancelButton = styled(Button)(({ theme }) => ({
  borderRadius: '30px',
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  color: theme.palette.primary.main,
  borderColor: theme.palette.primary.main,
  fontWeight: 500,
  textTransform: 'none',
  fontSize: '0.9rem',
  minWidth: '160px',
  width: '100%',
  marginBottom: theme.spacing(1),
  [theme.breakpoints.up('sm')]: {
    fontSize: '1rem',
    width: 'auto',
    marginBottom: 0,
  },
}));

export const ContinueButton = styled(Button)(({ theme }) => ({
  borderRadius: '30px',
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  fontWeight: 500,
  textTransform: 'none',
  fontSize: '0.9rem',
  minWidth: '160px',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    fontSize: '1rem',
    width: 'auto',
  },
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));
